import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdWifiOff } from 'react-icons/md';
import useStore from '../store/useStore';

export function OfflineBanner() {
  const isOnline = useStore((state) => state.isOnline);

  return (
    <>
      <ToastContainer />
      {!isOnline && (
          <div
            onClick={() => toast.error('Você está offline. Algumas funcionalidades podem estar limitadas.', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
            })}
            style={{
              position: 'fixed',
              top: '10%',
              right: '1rem',
              zIndex: 9999,
              backgroundColor: '#ef4444',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              cursor: 'pointer',
            }}
          >
            <MdWifiOff size={22} color="white" />
          </div>
      )}
    </>
  );
}
